// extracted by mini-css-extract-plugin
export default {"spinner":"styles-module--spinner--1rfZl","spin":"styles-module--spin--15qnr"};